import StructureProblem from '@/models/read/StructureProblem';

class StructureProblemCategory {
    constructor({
        title,
        types,
    }) {
        this._title = title;
        this._problems = this._determineProblems(types);
    }

    _determineProblems(types) {
        let structureProblems = [];
        types.forEach((type) => {
            type.areas.forEach((area) => {
                area.problems.forEach((problem) => {
                    if (problem.selected === true) {
                        structureProblems.push(new StructureProblem({
                            feedback: problem.feedback,
                            title: area.title,
                            label: problem.title,
                            url: problem.url,
                        }));
                    }
                });
            });
        });

        return structureProblems;
    }

    get title() {
        return this._title;
    }

    get problems() {
        return this._problems;
    }
}

export default StructureProblemCategory;
